"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemTypeTranslationMap = void 0;
var tslib_1 = require("tslib");
var lowerCase_1 = tslib_1.__importDefault(require("lodash/fp/lowerCase"));
exports.itemTypeTranslationMap = function (itemTypeName) {
    if (!itemTypeName) {
        return 'organization';
    }
    var name = lowerCase_1.default(itemTypeName);
    switch (name) {
        case 'investment manager':
            return 'manager';
        case 'investment':
            return 'investment';
        case 'person':
            return 'person';
        case 'file':
            return 'file';
        case 'event':
            return 'event';
        case 'benchmark':
            return 'benchmark';
        case 'manager':
            return 'manager';
        default:
            return 'organization';
    }
};
